import {useShopperCustomersMutation} from '@salesforce/commerce-sdk-react/hooks/ShopperCustomers/mutation'
import {ShopperCustomersMutations} from '@salesforce/commerce-sdk-react/hooks/ShopperCustomers/mutation'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'

export const useMutateCustomerProductList = () => {
    const config = getConfig()
    const {
        app: {commerceAPI}
    } = config
    const createProductListMutation = useShopperCustomersMutation(
        ShopperCustomersMutations.CreateCustomerProductList
    )
    const addProductListItemMutation = useShopperCustomersMutation(
        ShopperCustomersMutations.CreateCustomerProductListItem
    )
    const removeProductListItemMutation = useShopperCustomersMutation(
        ShopperCustomersMutations.DeleteCustomerProductListItem
    )

    const createProductList = async ({registeredCustomerId, listType}) => {
        if (registeredCustomerId) {
            try {
                const newProductList = await createProductListMutation.mutateAsync({
                    body: {type: listType},
                    parameters: {customerId: registeredCustomerId}
                })
                return newProductList
            } catch (e) {
                console.error(e)
            }
        }
    }

    const addItemToProductList = async ({registeredCustomerId, productId, productList}) => {
        let listId = productList?.id
        if (!listId) {
            const newList = await createProductList({registeredCustomerId, listType: 'wish_list'})
            listId = newList?.id
        }
        if (registeredCustomerId && listId && productId) {
            try {
                await addProductListItemMutation.mutateAsync({
                    parameters: {customerId: registeredCustomerId, listId},
                    body: {
                        id: productId,
                        productId: productId,
                        priority: 1,
                        public: false,
                        quantity: 1,
                        type: 'product'
                    }
                })
            } catch (e) {
                console.error(e)
            }
        }
    }

    const removeItemFromProductList = async ({registeredCustomerId, productId, productList}) => {
        const productListItems = productList?.customerProductListItems
        const productListItemId = productListItems?.find((item) => item.productId === productId)?.id
        if ((registeredCustomerId, productList?.id, productListItemId)) {
            try {
                await removeProductListItemMutation.mutateAsync({
                    parameters: {
                        customerId: registeredCustomerId,
                        listId: productList.id,
                        organizationId: commerceAPI.parameters.organizationId,
                        itemId: productListItemId
                    }
                })
            } catch (e) {
                console.error(e)
            }
        }
    }

    return {
        createProductListMutation,
        addItemToProductListMutation: addProductListItemMutation,
        removeItemFromProductListMutation: removeProductListItemMutation,
        addItemToProductList,
        removeItemFromProductList,
        createProductList
    }
}
